import { BaseModel } from './base.model';

export class StatusSortModel extends BaseModel {
  id: string[] = [];
}
